<footer class="footer">
  <div class="container h-100">
    <div class="row no-gutters justify-content-between align-items-center h-100">
      <div class="footer-information col-12 pt-4 pt-md-0 px-0" [ngClass]="['col-md-'+informationWidth]">
          <h2 class="h3 mt-0 mb-4">{{ leftPaneTitleKey | translate }}</h2>
          <p class="mb-0">
            <ng-container *ngFor="let content of leftPaneContent;  let last = last;" class="d-block">{{ content | translate }} <br *ngIf="!last"/></ng-container>
          </p>
      </div>
      <div role="list" class="footer-links py-4">
        <div *ngFor="let link of links;  let last = last;  let first = first;" class="link-container" role="listitem">
          <svg *ngIf="link.isExternal" width="4" height="10" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 8.443 2.472 5 0 1.558.761.5 4 5 .761 9.5 0 8.443Z" fill="#ECE5B7"/></svg>
          <a *ngIf="link.isExternal && !link.newTab" class="footer-link" [tabindex]="sidenavOpen ? -1 : 0" [href]="link.href">{{ link.titleKey | translate }}</a>
          <a *ngIf="link.isExternal && link.newTab" class="footer-link" [tabindex]="sidenavOpen ? -1 : 0" target="_blank" rel="noreferrer" [href]="link.href">{{ link.titleKey | translate }}</a>
        </div>
      </div>
    </div>
  </div>
 </footer>
